/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
// @flow

import moment from 'moment';
import {
  SI_GET_ALL_THEMES_REQUEST,
  SI_GET_ALL_THEMES_SUCCESS,
  SI_GET_ALL_THEMES_FAILURE,
  SI_UPDATE_ALL_THEMES,
  SIThemeState,
  SIThemeAction
} from 'stores/flow-type/shopify-integration/theme.type';

const initialState: SIThemeState = {
  getAllThemesLoading: false,
  allThemes: []
};

const shopifyIntegrationThemeReducers = (
  state: SIThemeState = initialState,
  action: SIThemeAction
) => {
  switch (action.type) {
    case SI_GET_ALL_THEMES_REQUEST:
      return { ...state, getAllThemesLoading: true, getAllThemesSuccess: false };
    case SI_GET_ALL_THEMES_SUCCESS: {
      const { data = [] } = action.payload;
      // Move live theme to the top
      const allThemesCloned = [...data];
      allThemesCloned.sort((a, b) => (moment(a.updated_at).isAfter(moment(b.updated_at)) ? -1 : 1));

      // Move live theme on top of list
      const liveThemeIndex = allThemesCloned.findIndex(theme => theme.role === 'main');
      if (liveThemeIndex !== -1) {
        const liveTheme = { ...allThemesCloned[liveThemeIndex] };
        allThemesCloned.splice(liveThemeIndex, 1);
        allThemesCloned.unshift(liveTheme);
      }

      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: true,
        error: undefined,
        allThemes: allThemesCloned
      };
    }
    case SI_GET_ALL_THEMES_FAILURE:
      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: false,
        error: action.payload
      };

    case SI_UPDATE_ALL_THEMES: {
      const { data } = action.payload
      return {
        ...state,
        allThemes: data
      };
    }
    default:
      return state;
  }
};
export default shopifyIntegrationThemeReducers;
